<script lang="ts" setup>
import LeButton from "@dsk/components/Button/LeButton.vue";
import LeHeading from "@dsk/components/Heading/LeHeading.vue";
import LeModal from "@dsk/components/LeModal.vue";
import type { ModalProps } from "@dsk/types";

const props = defineProps<
  ModalProps & {
    titleText: string;
    bodyText: string;
    confirmText: string;
  }
>();

const emit = defineEmits<{
  (event: "close"): void;
}>();
</script>

<template>
  <LeModal class="le-success-modal" :is-open="props.isOpen" @close="emit('close')">
    <template #title>
      <LeHeading tag="h1" size="m">{{ props.titleText }}</LeHeading>
    </template>

    <template #body>
      <p class="le-success-modal__text">
        {{ props.bodyText }}
      </p>
    </template>

    <template #buttons>
      <LeButton @click="emit('close')">
        {{ props.confirmText }}
      </LeButton>
    </template>
  </LeModal>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-success-modal {
  &__text {
    .body-text("m");
    white-space: pre-line;
  }
}
</style>
